import styled from 'styled-components';

import { commonSkeletonStyles, flexBetween, flexColumn } from '@/styles/common';

export const Wrapper = styled.div`
  width: 100%;
  max-width: 520px;
  ${flexColumn}
  gap: 10px;
`;

export const Header = styled.div`
  ${flexBetween};
  gap: 12px;
`;

export const List = styled.div`
  display: grid;
  grid-auto-rows: minmax(44px, auto);
  gap: 20px;
`;

export const Row = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 18px 100px 1fr;
  align-items: center;
  gap: 12px;
  border: 1px solid var(--border-secondary);
  border-radius: 12px;
  padding: 10px 16px;
  background: var(--bg-card);
`;

export const SkeletonLine = styled.div<{ width?: number; height?: number }>`
  width: ${({ width }) => (width !== undefined ? `${width}%` : '100%')};
  height: ${({ height }) => (height !== undefined ? `${height}px` : '10px')};
  border-radius: 28px;
  ${commonSkeletonStyles}
`;

export const Circle = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 999px;
  ${commonSkeletonStyles}
`;

export const Icon = styled.div`
  width: 28px;
  height: 20px;
  border-radius: 6px;
  ${commonSkeletonStyles}
`;
